import { Users, ShoppingCart, CheckCircle2, Euro, Globe } from "lucide-react";
import { MetricCard, fmt } from "./KarolMetricsCards";

const CHANNEL_LABELS = {
  online: "Online", pos: "POS", whatsapp: "WhatsApp",
  table: "Mesa", aggregator: "Agregador", other: "Outro",
};

export function KarolCustomerBehaviorSection({ behavior }) {
  if (!behavior || behavior.error) return null;
  const top = behavior.top_channels?.[0];
  return (
    <div className="space-y-3" data-testid="customer-behavior">
      <div className="flex items-center gap-2 px-1">
        <div className="h-px flex-1 bg-gray-100" />
        <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
          Comportamento dos clientes
        </span>
        <div className="h-px flex-1 bg-gray-100" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <MetricCard icon={Users}        label="Observados"    value={behavior.total_customers_observed ?? 0} />
        <MetricCard icon={ShoppingCart} label="Abandonos"     value={behavior.abandoned_carts_count ?? 0} />
        <MetricCard icon={CheckCircle2} label="Pedidos pagos" value={behavior.paid_orders_count ?? 0} accent />
        <MetricCard icon={Euro}         label="Ticket pago"   value={fmt(behavior.avg_ticket_paid)} />
      </div>
      {top && (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm px-4 py-3 flex items-center gap-3">
          <Globe className="w-4 h-4 text-gray-400 flex-shrink-0" />
          <span className="text-xs text-gray-400">Canal principal</span>
          <span className="text-sm font-semibold text-gray-800 ml-auto capitalize">
            {CHANNEL_LABELS[top.channel] ?? top.channel}
          </span>
          <span className="text-xs text-gray-400 ml-1">({top.count})</span>
        </div>
      )}
    </div>
  );
}
